import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import Modal from '../../../../components/Modal/Modal';
import getOrderInvoice from '../../../../thunks/coilovers/orders/getOrderInvoice';
import clearInvoiceView from '../../../../actions/coilovers/orders/getOrderInvoice';
import Button from '../../../../components/Button/Button';

const modalBodyClassName = 'w-[800px] overflow-auto';
const modalSubHeaderClassName = 'mb-[20px]';

const CoOrderViewInvoiceModal = ({
    visible, toggleVisible, orderId
}) => {
  const dispatch = useDispatch();
  const {
    data, loading
  } = useSelector((state) => state.getOrderInvoice);

  useEffect(() => {
    if (orderId) {
        // fetch invoice data here
      dispatch(getOrderInvoice(orderId));
    }
  }, [orderId]);
  const onToggleVisible = () => {
    dispatch(clearInvoiceView());
    toggleVisible();
  };

  const onDownloadInvoice = () => {
    if (data && data?.pdf_url) {
        window.open(data.pdf_url, '_blank');
    }
  };

  return (
    <Modal
      visible={visible}
      toggleVisible={onToggleVisible}
      title="Invoice view"
      subTitle={`Order ID: ${orderId}`}
      hideSaveBtn
      loading={loading}
    >
      <div className={`${modalBodyClassName} customScroll`}>
        {data?.pdf_url && (
          <div className={modalSubHeaderClassName}>
            <Button onClick={onDownloadInvoice} type="primary" text="Download Invoice" />
          </div>
        )}
        <div>
          {/* eslint-disable-next-line react/no-danger */}
          <div dangerouslySetInnerHTML={{
            __html: data?.html || ''
          }}
          />
        </div>
      </div>
    </Modal>
  );
};

CoOrderViewInvoiceModal.propTypes = {
  orderId: PropTypes.string.isRequired,
  toggleVisible: PropTypes.func,
  visible: PropTypes.bool,
};

CoOrderViewInvoiceModal.defaultProps = {
    visible: false,
    toggleVisible: () => {}
};

export default CoOrderViewInvoiceModal;
